import React from 'react'

import { Typography } from '@s4l/ds'
import { useS4LContext } from '@s4l/react-context'
import { useBrowser } from '@s4l/utils/hooks/useBrowser'

import styles from './index.module.css'

export function AdvantageTitle() {
  const { i18n } = useS4LContext()
  const { device } = useBrowser()
  return (
    <Typography variant="title" size={device === 'mobile' ? 's' : 'm'}>
      {i18n.formatMessage(
        { id: 'advantages.title' },
        {
          emphasis: (
            <span className={styles.featuredText}>
              {i18n.formatMessage({ id: 'advantages.title-emphasis' })}
            </span>
          ),
        }
      )}
    </Typography>
  )
}
AdvantageTitle.displayName = 'AdvantageTitle'
